import { Component } from '@angular/core';
import { ToolsService } from './providers/tools.service';
import { environment } from 'src/environments/environment';
import { initializeApp } from 'firebase/app';
import { applyMatSelectBulkSelectionPatch } from './utils/mat-select-bulk-selection-patch';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  constructor(public tools: ToolsService) {
    applyMatSelectBulkSelectionPatch();
    initializeApp(environment.FIREBASE_CREDENTIAL);
  }
}
